export class SystemVariableModel {
    text: string;
    code: string;

    constructor(text: string, code?: string) {
        this.text = text;
        this.code = code !== undefined ? code : text;
    }
}
